import { AxiosService } from './axiosService';

export class UserService extends AxiosService {
    async searchUsers(searchText) {
        try {
            const { data } = await this.axios.get('/customer', {
                params: {
                    searchText: searchText,
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getUsers(pageSize, pageIndex, sortField, sortDirection) {
        try {
            const { data } = await this.axios.get('/users', {
                params: {
                    pageSize: pageSize,
                    pageIndex: pageIndex,
                    sortBy: sortField,
                    orderBy: sortDirection
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async toggleUserActive(userId, inactive) {
        try {
            const { data } = await this.axios.put('/users/active', {
                id: userId,
                inactive
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async editUser(userId, notes, firstName, lastName, email, phoneNumber, userRole, distributorId) {
        try {
            const { data } = await this.axios.put('/users', {
                Id: userId,
                notes: notes,
                firstname: firstName,
                lastname: lastName,
                email: email,
                phoneNumber: phoneNumber,
                roleId: userRole,
                distributorId
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postUser(notes, firstName, lastName, email, phoneNumber, userRole, password, distributorId) {
        try {
            const { data } = await this.axios.post('/users', {
                notes: notes,
                firstName: firstName,
                lastName: lastName,
                email: email,
                phoneNumber: phoneNumber,
                roleId: userRole,
                password: password,
                distributorId
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteUser(userId) {
        try {
            const { data } = await this.axios.delete('/users', {
                data: {
                    id: userId
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async changePassword(currentPassword, newPassword, newPasswordConfirm) {
        try {
            const { data } = await this.axios.post('/users/change-password', {
                currentPassword,
                newPassword,
                newPasswordConfirm
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async forgotPassword(username) {
        try {
            const { data } = await this.axios.post('/users/forgot-password', {
                username
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async forgotPasswordChange(resetToken, userId, password, passwordConfirm) {
        try {
            const { data } = await this.axios.post('/users/forgot-password-change', {
                resetToken,
                userId,
                password,
                passwordConfirm
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const userService = new UserService();
